<template>
  <modal
    class="new-editor-modal timeless-interval-modal"
    name="timeless-interval-modal"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="40%"
    height="auto"
    style="z-index: 2001;"
  >
    <div id="modal-header"  class="action-modal">
      <div class="w-100 d-flex text-left">
        <p class="text-left">Սահմանված քանակների շեմեր և դրանց համապատասխան գներ</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('timeless-interval-modal')"
              aria-label="Close"
      >
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
          </svg>
      </button>
    </div>
    <div id="modal-body" class="padding-20">
<!--      <div class="d-flex p-0 col-auto">-->
<!--        <p class="mr-2" style="font-size: 16px">-->
<!--          Ընդհանուր քանակ` <span style="color: #006BE6; font-weight: 600">{{totalCount}}</span>-->
<!--        </p>-->
<!--      </div>-->
      <div class="interval-block d-flex flex-column">
        <table class="table details-table table-border-radius">
          <thead>
            <tr>
              <th class="text-center">Շեմեր</th>
              <th class="text-center">Գումար</th>
              <th class="text-center">ԱԱՀ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(intervalRow, index) in intervalRows" :key="index">
              <td>{{intervalRow.min_count}} - {{intervalRow.max_count}}</td>
              <td>{{intervalRow.price}}</td>
              <td>{{intervalRow.is_with_vat ? 'ԱԱՀ-ով' : 'առանց ԱԱՀ'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
    name: 'TimelessIntervalModal',
    data() {
      return {
        intervalRows: [
          {
            min_count: 1,
            max_count: null,
            price: null,
            is_with_vat: false,
          }
        ],
        title: '',
        text: false,
        alertMsg: false,
        equalPrice: false,
        callback: null,
        loading: false
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
    methods: {
      addRow(index) {
        this.intervalRows.push({
          min_count: this.intervalRows[index].max_count,
          max_count: null,
          price: null,
          is_with_vat: false,
        })
      },
      handleBeforeOpen({ params }) {
        this.loading = false
        console.log(params)
        if(params?.priceIntervalArray?.length){
          this.intervalRows = params.priceIntervalArray;
        } else {
          this.intervalRows = [
            {
              min_count: 1,
              max_count: this.totalCount,
              price: null,
              is_with_vat: false,
            }
          ];
        }
        this.callback = params.callback;
      },
      confirm() {
        this.loading = true;
        console.log(this.intervalRows);
        this.intervalRows[this.intervalRows.length - 1].max_count = this.totalCount
        if (!this.$v.intervalRows.$invalid) {
          this.callback(this.intervalRows);
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
          this.loading = false;
        }
      }
    }
  }
</script>
<style>
  .tab {
      margin-left: 25px;
  }
</style>
<style scoped>

</style>
